import { Link } from 'react-router-dom';
import { dailyUpdates } from '@/mocks/home';

export default function DailyUpdateSection() {
  return (
    <section id="daily-updates" className="w-full px-4 md:px-6 lg:px-12 py-14 md:py-20 bg-background-50">
      <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
        <div className="lg:w-[35%]">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 mb-4">
            每日更新
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight">
            番剧<br />追更日历
          </h2>
          <p className="text-sm text-foreground-500 mt-6 leading-relaxed">
            实时追踪最新番剧更新动态，掌握每日更新节奏。不再错过任何一集的精彩内容，追番路上我们一直都在。
          </p>
          <div className="mt-8 hidden lg:block">
            <div className="bg-accent-100/60 rounded-lg p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center">
                  <i className="ri-notification-3-line text-background-50 text-lg"></i>
                </div>
                <span className="text-sm font-medium text-accent-800">更新提醒</span>
              </div>
              <p className="text-sm text-accent-700 leading-relaxed">
                工作日每日上午10点、中午12点准时更新。周末番剧将提前至上午10点发布，敬请期待！
              </p>
            </div>
          </div>
        </div>

        <div className="lg:w-[65%]">
          <div className="bg-background-100 rounded-lg p-4 md:p-6">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
              {dailyUpdates.map((anime) => (
                <Link
                  key={anime.id}
                  to="/category/all"
                  className="flex items-center gap-3 p-2.5 rounded-lg hover:bg-background-50 transition-colors group"
                >
                  <div className="w-12 h-16 rounded-md overflow-hidden flex-shrink-0">
                    <img
                      src={anime.image}
                      alt={anime.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h4 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                      {anime.title}
                    </h4>
                    <p className="text-xs text-foreground-500 mt-0.5">{anime.episode}</p>
                    <div className="flex items-center gap-1.5 mt-1">
                      <span className="text-xs text-foreground-400">{anime.day}</span>
                      <span className={`text-xs font-medium ${
                        anime.status === '已更新' ? 'text-accent-600' : 'text-secondary-600'
                      }`}>
                        {anime.status}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="mt-4 text-center">
            <Link
              to="/category/guoman"
              className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors"
            >
              查看全部更新 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}